import { defineMessage } from 'services/localization';

export const messages = {
    popupTitle: defineMessage('oracle_netsuite_account_connection'),
    connectButton: defineMessage('connect'),
    connectionError: defineMessage('failed_to_connect_to_oracle_netsuite'),
    connectionTitle: defineMessage('oracle_netsuite_connection'),
    saveTimeZoneError: defineMessage('failed_to_save_company_time_zone'),
    accountIdFieldTitle: defineMessage('oracle_netsuite_account_id'),
    accountIdFieldTooltipText: defineMessage('copy_the_account_id_fro_any_company_information'),
    accountIdWarning: defineMessage('fieldname_should_includ__numbers_and_underscore'),
    consumerKeyFieldTitle: defineMessage('consumer_key'),
    consumerKeyFieldTooltipText: defineMessage('create_integration_in_s_lue_wont_be_shown_again'),
    consumerSecretFieldTitle: defineMessage('consumer_secret'),
    consumerSecretFieldTooltipText: defineMessage('create_integration_in_s_lue_wont_be_shown_again_1'),
    tokenIdFieldTitle: defineMessage('token_id'),
    tokenIdFieldTooltipText: defineMessage('create_new_token_in_set_lue_wont_be_shown_again'),
    tokenSecretFieldTitle: defineMessage('token_secret'),
    tokenSecretFieldTooltipText: defineMessage('copy_token_secret_from__lue_wont_be_shown_again'),
    subsidiaryIdFieldTitle: defineMessage('subsidiary_id'),
    subsidiaryIdFieldTooltipText: defineMessage('copy_the_internal_id_of_up_company_subsidiaries'),
    subsidiaryIdWarning: defineMessage('fieldname_should_be_a_single_int_number'),
    timeZoneFieldTitle: defineMessage('time_zone'),
    timeZoneFieldTooltipText: defineMessage('copy_the_timezone_of_th_om_home_set_preferences'),
    timeZonePlaceholder: defineMessage('time_zone'),
    companyCreationError: defineMessage('failed_to_create_company'),
    suiteAppConnection: defineMessage('suiteapp_connection'),
    learnMore: defineMessage('learn_more'),
    alphaNumericWarning: defineMessage('fieldname_should_includ_tin_letters_and_numbers'),
    requiredWarning: defineMessage('fieldname_is_required'),
    imageAltText: defineMessage('fieldname_setup_instructions'),
    isSuiteAppWarning: defineMessage('activate_this_option_on_nd_consumer_secret_keys'),
};
